import React from 'react';
import PropTypes from 'prop-types';
import { FDStack, Paper } from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { TitleTextLarge } from 'Packages/FacetDesign/Components';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { LottieControl } from 'Organisms/LottieControl';
import { useLottieLoadingContext } from 'Organisms/LottieControl/LottieLoadingLayout';
import ErrorList from 'Components/UI/ErrorList';
import SocialSecurityField from 'Components/UI/Accounts/AccountApplication/Step/Fields/SocialSecurityField';

const Layout = ({ errors }) => {
  const { resource } = useMetaLayoutContext();
  const { setIsContentShowing } = useLottieLoadingContext();

  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (
    <FDStack direction="column" spacing={4} paddingY={4} justifyContent={'center'} alignItems={'center'} width={'100%'}>
      <FDStack direction="column" justifyContent={'center'} alignItems={'center'} spacing={2} maxWidth={'80%'}>
        <MetaField attr="title" />
        <MetaField attr="subtitle" />
      </FDStack>
      <Paper padding={400} width={'50%'} appearance={'elevated'}>
        <FDStack direction="column" spacing={2}>
          {resource.withRelationship(fr.relationships.icon.name,
            (rel) => (
              <FDStack width="100%" justifyContent="center">
                <img alt={rel.meta('prompt')} src={rel.link('related').url()} width={50} height={50} />
              </FDStack>
            ),
            () => null)}
          <TitleTextLarge align={'center'} value={'Account you’re moving money from'} />
          <MetaField attr="originAccountInstitution" />
          <MetaField attr="originAccountOtherName" />
          <MetaField attr="originAccountNumber" />
          <SocialSecurityField attr="socialSecurityNumber" />
          <MetaField attr="originAccountType" />
          <MetaField attr="contributionsType" />
        </FDStack>
      </Paper>
      <ErrorList title={'Errors occurred while submitting'} errors={errors} />

      {resource.withRelationship(fr.relationships.transferLottieVertical.name,
        (rel) => (
          <LottieControl
            src={rel.link('related').url()}
            onLoadSuccess={() => setIsContentShowing(true)}
            onLoadError={() => setIsContentShowing(true)}
            height={'auto'}
            width={'100%'}
          />
        ),
        () => null)}
      <FDStack direction={'row'} justifyContent={'center'} spacing={2} width={'100%'}>
        <MetaField attr="destinationAccountName" />
        <MetaField attr="secondaryDestinationAccountName" />
      </FDStack>
    </FDStack>
  );
};

Layout.defaultProps = {
  errors: [],
};

Layout.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object),
};

export default Layout;
